<!-- 由 suu 创建于 2025-03-21 星期五 -->
<template>
  <div class="PreviewImageSave">
    <van-image-preview
      v-model="showPreview"
      :images="previewImages"
      :start-position="showPreviewIndex"
      :show-index="false"
      :overlay-style="overlayStyle"
      closeable
      close-icon="arrow-left"
      close-icon-position="top-left"
      @change="onChange"
      @close="onClose"
    >
      <template v-slot:cover>
        <div class="cover-index" v-if="previewImages.length > 1">
          <!-- <div class="cover-index"> -->
          <span class="cover-index-num">{{ curPreviewIndex + 1 }}</span>
          <span class="cover-index-slash">/</span>
          <span class="cover-index-total">{{ previewImages.length }}</span>
        </div>
        <!-- <img :src="saveImageUrl" alt="" /> -->
        <div class="cover-btn user-btn" v-if="btwId" @click="onUserBtn"
          >去Ta的圈子</div
        >
      </template>
    </van-image-preview>
    <van-action-sheet
      v-model="showSheet"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
    />
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import html2canvas from 'html2canvas'

export default {
  name: 'PreviewImageSave',

  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  },

  props: {
    // 初始化下标
    showPreviewIndex: {
      type: Number,
      default: 0
    },
    // 图片列表
    previewImages: {
      type: Array,
      default: () => []
    },
    showWatermark: {
      type: Boolean,
      default: true
    },
    btwId: {
      type: [String, Number],
      default: ''
    },
    isApp: {
      type: [Boolean, Number],
      default: false
    }
  },

  data() {
    return {
      eventHandlers: null,
      showPreview: true,
      curPreviewIndex: 0,
      overlayStyle: {
        backgroundColor: 'rgba(0, 0, 0, 1)'
      },
      showSheet: false,
      actions: [
        {
          key: 1,
          name: '保存图片',
          color: '#07c160'
        }
      ],
      imagesDom: [],
      saveImageUrl: '',
      isIOS: false
    }
  },

  computed: {
    doEventListeners() {
      // 只有App 并且是IOS 才绑定长按保存事件 安卓在app中有兼容问题 touchstart事件这按下时不能直接触发
      return this.$betterwe.isApp() && this.isIOS
      // return true
    }
  },

  watch: {},

  created() {
    let agent = (
      navigator.userAgent ||
      navigator.vendor ||
      window.opera
    ).toLowerCase()
    this.isIOS =
      /ipad|iphone|ipod/.test(agent) || /macintosh|mac os x/i.test(agent)
  },

  mounted() {
    this.showImagePreview()
  },

  destroyed() {},

  methods: {
    onChange(index) {
      this.curPreviewIndex = index
      this.setupEventListenersAndWatermark()
    },
    onClose() {
      this.removeImageEventListeners() // 清理事件监听
      this.$emit('close')
    },
    showImagePreview() {
      this.imagesDom = new Array(this.previewImages.length).fill(null)
      this.curPreviewIndex = this.showPreviewIndex

      const PRESS_TIME = 500

      this.eventHandlers = {
        touchstart: (e) => {
          console.log('touchstart', e)
          this.imagesDom[this.curPreviewIndex]['pressTimer'] = setTimeout(
            () => {
              this.handleShowSaveBtn(e)
            },
            PRESS_TIME
          )
        },
        touchmove: (e) => {
          console.log('touchmove', e)
          // if (this.imagesDom[this.curPreviewIndex]['pressTimer']) {
          //   clearTimeout(this.imagesDom[this.curPreviewIndex]['pressTimer'])
          // }
        },
        touchend: () => {
          console.log('touchend')
          if (this.imagesDom[this.curPreviewIndex]['pressTimer']) {
            clearTimeout(this.imagesDom[this.curPreviewIndex]['pressTimer'])
          }
        }
      }
      this.$nextTick(() => {
        // 监听图片事件
        setTimeout(() => {
          this.setupEventListenersAndWatermark()
        }, 200)
      })
    },

    setupEventListenersAndWatermark() {
      // console.log('this.imagesDom1', this.imagesDom, this.curPreviewIndex)
      if (!this.imagesDom[this.curPreviewIndex]) {
        let obj = {}
        const container = document.querySelector('.van-image-preview__swipe')
        // 直接找van-image-preview__image 不行 因为vant虚拟dom加载后 图片是隐藏的 只有当前index和前一个 后一个真正加载了 需要找van-image-preview__swipe-item
        const imagesFather = container?.querySelectorAll(
          '.van-image-preview__swipe-item'
        )
        // console.log('this.container', container, imagesFather)
        const image = imagesFather[this.curPreviewIndex]?.querySelector(
          '.van-image-preview__image'
        )
        // console.log('this.image', image)
        if (!image) {
          // this.showPreview && this.setupEventListenersAndWatermark()
          return
        }
        if (this.doEventListeners && image) {
          image.addEventListener('touchstart', this.eventHandlers.touchstart)
          image.addEventListener('touchmove', this.eventHandlers.touchmove)
          image.addEventListener('touchend', this.eventHandlers.touchend)
        }
        obj.dom = image
        // 创建并设置水印图片 并且没有添加过 （避免vant虚拟dom加载后重复添加之前已经加载过的）
        if (this.showWatermark && image) {
          let watermark = document.createElement('img')
          watermark.className = 'my-cover-logo'
          watermark.src = 'https://cdnvue.gymcity.com.cn/uploads/pub-white-logo'
          watermark.style.cssText =
            'position: absolute; bottom: 12px; right: 20px; width: 169px; z-index: 999;'
          image.style.position = 'relative'
          image.appendChild(watermark)
          obj.watermark = 1
        }
        this.imagesDom[this.curPreviewIndex] = obj
      }
      // console.log('this.imagesDom2', this.imagesDom, this.curPreviewIndex)
    },

    removeImageEventListeners() {
      if (!this.doEventListeners) return
      if (this.imagesDom?.length && this.eventHandlers) {
        this.imagesDom.forEach((item) => {
          if (item && item.dom) {
            item.dom.removeEventListener(
              'touchstart',
              this.eventHandlers.touchstart
            )
            item.dom.removeEventListener(
              'touchmove',
              this.eventHandlers.touchmove
            )
            item.dom.removeEventListener(
              'touchend',
              this.eventHandlers.touchend
            )
          }
        })
      }
    },

    handleShowSaveBtn(event) {
      this.showSheet = true
    },
    // 合并水印和图片并保存
    saveImage(imgUrl) {
      const that = this
      if (this.showWatermark) {
        this.$toast.loading('正在保存图片...')
        const cueDom = this.imagesDom[this.curPreviewIndex].dom
        html2canvas(cueDom, {
          backgroundColor: null,
          useCORS: true
        })
          .then((canvas) => {
            that.$toast.clear()
            const base64 = canvas.toDataURL()
            // that.saveImageUrl = base64
            that.doSaveImage(base64, 'base64')
          })
          .catch((err) => {
            console.log(err)
            that.$toast.clear()
            that.$toast('保存图片失败')
          })
          .finally(() => {})
      } else {
        this.doSaveImage(imgUrl, 'url')
      }
    },
    doSaveImage(img, type) {
      if (this.$betterwe.saveImage) {
        this.$betterwe.saveImage({
          data: img,
          type: type
        })
      } else {
        console.log(
          'this.$betterwe.onAppSaveImage',
          this.$betterwe,
          this.$betterwe.onAppSaveImage
        )
        this.$betterwe.onAppsaveImage({
          data: img,
          type: type
        })
      }
    },
    onSelect(action) {
      console.log('action', action)
      if (action.key === 1) {
        this.saveImage(this.previewImages[this.curPreviewIndex])
      }
    },
    onUserBtn() {
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练主页-去圈子`,
        from_id: 250326
      })
      this.$betterwe.jumpRoute(`/gymCoachDetails?id=${this.btwId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.PreviewImageSave {
  .cover-logo {
    width: 180px;
    position: fixed;
    top: 50%;
    left: 20px;
    transform: translateY(160px);
  }
  .cover-index {
    width: 40px;
    height: 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1px;
    font-weight: 300;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 210px);
    background: rgba($color: #050b27, $alpha: 0.8);
    box-sizing: border-box;
    border-radius: 12px;
    color: rgba($color: #fff, $alpha: 0.5);
    .cover-index-slash {
      font-size: 8px;
      margin: 0 1px;
    }
    .cover-index-num {
      color: #fff;
      font-weight: 600;
    }
  }
  .cover-btn {
    width: 246px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #050b27;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 250px);
    z-index: 9;
  }
  ::v-deep {
    .van-image-preview__close-icon {
      font-size: 18px;
      color: #fff;
      font-weight: 600;
      padding: 10px;
      top: 38px;
      left: 10px;
    }
  }
}
</style>
